export default "__VITE_ASSET__DEZSe6E4__"